"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_helper_1 = require("../helpers/cookie-helper");
var User = (function () {
    function User() {
    }
    Object.defineProperty(User.prototype, "username", {
        get: function () {
            return this._username;
        },
        set: function (username) {
            this._username = username;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "password", {
        get: function () {
            return this._password;
        },
        set: function (password) {
            this._password = password;
        },
        enumerable: true,
        configurable: true
    });
    User.prototype.isLogggedIn = function () {
        if (cookie_helper_1.default.get('uName') !== undefined && cookie_helper_1.default.get('uName') != '' && cookie_helper_1.default.get('uName') != null && cookie_helper_1.default.get('token') != '' && cookie_helper_1.default.get('token') != null && cookie_helper_1.default.get('token') !== undefined) {
            return true;
        }
        return false;
    };
    return User;
}());
exports.default = User;



//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/ts/user/user.ts
// module id = 2426
// module chunks = 10